const releaseItem = {
  "id": "",
  "project": {
    "product_line": {
      "name": "",
      "background_color": "",
      "text_color": "",
    },
    "name": "",
    "icon": ""
  },
  "is_common": true,
  "release_at": "",
  "url": "",
  "version": "",
  "note": "",
  "area": ""
};


const getLogoSrc = (icon) => {
  if (icon === null) icon = ""
  let name = icon.indexOf('jpg') !== -1 ? icon : 'ic_default@2x.jpg';
  return require(`../../assets/image/${name}`);
}

const getTagStyle = (product_line) => {
  return `background: ${product_line.background_color}; color: ${product_line.text_color}`
}

export {
  releaseItem,
  getLogoSrc,
  getTagStyle,
};
